import React, { Fragment } from "react";
import AdminTemplate from "components/templates/AdminTemplate";
import { useTranslation } from "react-i18next";
import CreateUserFormRoles from "components/organism/CreateUserFormRoles";

const UserRolesForm = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <AdminTemplate
        heading={t("dashboard.label19")}
        subheading={t("createRoles.subHeading")}
        icon="note2"
      >
        <CreateUserFormRoles />
      </AdminTemplate>
    </Fragment>
  );
};

export default UserRolesForm;
